<ng-container *transloco="let t;">
    <div class="form-group mt-2 mb-2">
        <label class="col-form-label pt-0 pb-0" for="name">{{t("Upload file after sign checkbox (Template/Document - section) - Allow participants to upload files")}}</label>
        <div class="form-group d-flex justify-content-between align-items-center pt-25">
            <label [ngClass]="{'pointer-none': !_field?.value, 'text-primary': _field?.value}" class="pt-0 pb-0 mb-0 cursor-pointer" for="allow_upload_file">
                @if(_field?.value){
                    {{t("Modal button (general) - Yes")}}
                }@else{
                    {{t("Modal button (general) - No")}}
                }   
            </label>
            <div class="custom-control custom-control-primary custom-switch ">
                <input type="checkbox" [disabled]="!canEdit" class="custom-control-input" id="allow_upload_file" (change)="onChangeAllowUploadFile($event.target.checked)" [(ngModel)]="_field.value" />
                <label class="custom-control-label" for="allow_upload_file"></label>
            </div>
        </div>
    </div>
</ng-container>